<template>
    <div class="pl-column-edit-item" @click="handleClick">
        <keep-alive>
            <link-timepicker
                v-model="showRow[field]"
                v-if="lv_editable"
                :required="lv_required"
                :rules="rules"
                :validate-on-init="validateOnInit"
                :display-format="displayFormat"
                :value-format="valueFormat"

                :type="type"
                :color="color"
                :size="size"
                :shape="shape"
                :dashed="dashed"
                :long="long"
                :prefixIcon="prefixIcon"
                :suffixIcon="suffixIcon"
                :disabled="disabled"
            />
            <template v-else>
                <link-table-cell-normal
                    :render-func="renderFunc"
                    :scope-slot-func="scopeSlotFunc"
                    :text="showRow[field]"
                    :data="scopeSlotData"/>
            </template>
        </keep-alive>
    </div>
</template>

<script>
    import {ColumnItemMixin} from "../mixins";
    import LvColumnText from "../lv-column-text";
    import LvScopeSlot from "../../render/lv-scope-slot";

    export default {
        name: 'link-table-column-timepicker-item',
        components: {LvScopeSlot, LvColumnText},
        mixins: [ColumnItemMixin],
        props: {
            value: {type: String},
            displayFormat: {type: String, default: 'HH:mm:ss'},
            valueFormat: {type: String, default: 'HH:mm:ss'},
            noInput: {type: Boolean, default: false},
            hideOnClickOutSide: {type: Boolean, default: true},
            direction: {default: 'bottom'},
            align: {default: 'start'},
            show: {type: Boolean, default: false},
            type: {type: String, default: 'line',},
            color: {type: String, default: 'info',},
            size: {type: String, default: 'default',},
            shape: {type: String, default: 'none',},
            dashed: {type: Boolean,},
            long: {type: Boolean,},
            prefixIcon: {type: String},
            suffixIcon: {type: String, default: 'link-icon-time-circle'},
            placeholder: {type: String, default: '点击输入内容'},
            disabled: {type: Boolean},
            readonly: {type: Boolean},
            clearable: {type: Boolean},
            regexp: {type: RegExp},
        },
    };
</script>
